'use strict';

import { Iospicker } from './iospicker.js';

export class IospickerSneakpiciospicker {
	
	constructor(component_id) {
		//super(component_id);
		this.id = component_id;
		this.vars = yalwa.v.components[this.id];
		this.$root = jQuery(`.js-${this.id}`);
		this.$wheel = this.$root.find('.iospicker__wheel');
		this.$items = this.$root.find('.iospicker__item');
		this.item_height = 44;
		this.dragging = false;
		this.startY = 0;
		this.startScrollTop = 0;
	}
	
	init() {
		this.bind_events();
		this.scroll_to_selected();
	}

	scroll_to_selected() {
		const default_value = this.vars.selected || '9';
		const $target = this.$root.find(`.iospicker__item[data-value="${default_value}"]`);
		if (!$target.length) {
			return;
		}

		const wheel = this.$wheel[0];
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				const item_center = $target[0].offsetTop + (this.item_height / 2);
				const wheel_center = wheel.clientHeight / 2;
				wheel.scrollTop = item_center - wheel_center;
				this.update_wheel();
			});
		});
	}

	bind_events() {
		const wheel = this.$wheel[0];

		// Native scroll (touch + mouse wheel)
		this.$wheel.on('scroll', this.handle_scroll.bind(this));

		// Mouse drag + wheel — only on non-touch devices
		if (!('ontouchstart' in window)) {
			this.$wheel.on('mousedown', this.on_drag_start.bind(this));
			this.$wheel.on('wheel', this.on_wheel.bind(this), {passive: false});
		}
	}

	on_drag_start(e) {
		e.preventDefault();
		this.dragging = true;
		this.startY = e.clientY;
		this.startScrollTop = this.$wheel[0].scrollTop;
		this.$wheel.addClass('iospicker__wheel--dragging');
		jQuery(document).on('mousemove.iospicker_drag', this.on_drag_move.bind(this));
		jQuery(document).on('mouseup.iospicker_drag', this.on_drag_end.bind(this));
	}

	on_drag_move(e) {
		if (!this.dragging) {
			return;
		}
		e.preventDefault();
		const deltaY = e.clientY - this.startY;
		this.$wheel[0].scrollTop = this.startScrollTop - deltaY;
	}

	on_drag_end(e) {
		if (!this.dragging) {
			return;
		}
		this.dragging = false;
		this.$wheel.removeClass('iospicker__wheel--dragging');
		jQuery(document).off('.iospicker_drag');

		// Snap to nearest item
		this.snap_to_nearest();
	}

	on_wheel(e) {
		e.preventDefault();
		const wheel = this.$wheel[0];
		const direction = e.deltaY > 0 ? 1 : -1;
		wheel.scrollTop += direction * this.item_height;
	}

	snap_to_nearest() {
		const wheel = this.$wheel[0];
		const wheel_center = wheel.scrollTop + (wheel.clientHeight / 2);
		let closest = null;
		let closest_dist = Infinity;

		this.$items.each((i, item) => {
			const item_center = item.offsetTop + (this.item_height / 2);
			const dist = Math.abs(item_center - wheel_center);
			if (dist < closest_dist) {
				closest_dist = dist;
				closest = item;
			}
		});

		if (closest) {
			const item_center = closest.offsetTop + (this.item_height / 2);
			wheel.scrollTop = item_center - (wheel.clientHeight / 2);
		}
	}
	
	handle_scroll() {
		window.requestAnimationFrame(
			this.update_wheel.bind(this)
		);
	}
	
	update_wheel() {
		const wheel = this.$wheel[0];
		const scroll_top = wheel.scrollTop;
		const wheel_center =
			scroll_top +
			(wheel.clientHeight / 2);
		const radius = 16;
		const angle_step = 8;
		let active_item = null;
		let closest_distance = Infinity;
		this.$items.each((index, item) => {
			const item_center =
				item.offsetTop +
				(this.item_height / 2);
			
			const distance =
				item_center - wheel_center;
			
			const angle =
				distance / this.item_height *
				angle_step;
			
			const abs_distance =
				Math.abs(distance);
			
			const opacity =
				Math.max(
					0,
					1 - (abs_distance / 180)
				);
			
			item.style.transform = `
			rotateX(${-angle}deg)
			translateZ(${radius}px)
		`;
			
			item.style.opacity = opacity;
			
			item.style.zIndex =
				1000 - Math.floor(abs_distance);
			
			item.classList.remove(
				'iospicker__item--active'
			);
			
			if (abs_distance < closest_distance) {
				closest_distance =
					abs_distance;
				active_item = item;
			}
		});
		
		if (active_item) {
			active_item.classList.add(
				'iospicker__item--active'
			);
			let $label_el = jQuery('.js-sneakpic_info_label');
			let $html = (active_item.dataset['value'] >= 900) ? $label_el.data('view_once_label') : $label_el.data('default_label');
			$label_el.html($html);
			
		}
	}
}